import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import axios from "axios";

const AdminDS = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [stakeholderData, setStakeholderData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRole, setSelectedRole] = useState("All");
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showLahanModal, setShowLahanModal] = useState(false);
  const [selectedPetani, setSelectedPetani] = useState(null);
  const [tanggal, setTanggal] = useState("");

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    role: "",
    nama: "",
    nomor_hp: "",
    alamat_rumah: "",
    alamat_kebun: "",
    alamat_pabrik: "",
    kapasitas_penyimpanan: "",
    kapasitas_produksi: "",
    jenis_sawit: "",
    jenis_pupuk: "",
    lahans: [
      {
        nama_lahan: "",
        alamat_lahan: "",
        status_sertifikasi_lahan: "",
        luas_lahan: "",
      },
    ],
  });

  const [lahanFormData, setLahanFormData] = useState({
    nama_lahan: "",
    alamat_lahan: "",
    status_sertifikasi_lahan: "",
    luas_lahan: "",
    jenis_tanah: "",
  });

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/users"
        );
        setStakeholderData(response.data.users || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
        Swal.fire("Error", "Gagal mengambil data pengguna!", "error");
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout request gagal:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleOpenRegisterModal = () => {
    setFormData({
      username: "",
      password: "",
      email: "",
      role: "",
      nama: "",
      nomor_hp: "",
      alamat_rumah: "",
      alamat_kebun: "",
      alamat_pabrik: "",
      kapasitas_penyimpanan: "",
      kapasitas_produksi: "",
      jenis_sawit: "",
      jenis_pupuk: "",
      lahans: [
        {
          nama_lahan: "",
          alamat_lahan: "",
          status_sertifikasi_lahan: "",
          luas_lahan: "",
        },
      ],
    });
    setShowRegisterModal(true);
  };

  const handleOpenLahanModal = (stakeholder) => {
    setSelectedPetani(stakeholder);
    setLahanFormData({
      nama_lahan: "",
      alamat_lahan: "",
      status_sertifikasi_lahan: "",
      luas_lahan: "",
      jenis_tanah: "",
    });
    setShowLahanModal(true);
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const filteredData =
    selectedRole === "All"
      ? stakeholderData
      : stakeholderData.filter(
          (stakeholder) => stakeholder.role === selectedRole
        );

  const handleRegisterSubmit = async () => {
    const requestData = {
      ...formData,
      lahans:
        formData.role === "petani"
          ? formData.lahans.map((lahan) => ({
              ...lahan,
              luas_lahan: parseFloat(lahan.luas_lahan || 0),
            }))
          : [],
    };

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/register",
        requestData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      Swal.fire({
        title: "Sukses",
        text: response.data.message || "Pengguna berhasil didaftarkan!",
        icon: "success",
        confirmButtonColor: "#198754",
      });
      setShowRegisterModal(false);

      const res = await axios.get("https://c-greenproject.org:7500/users");
      setStakeholderData(res.data.users || []);
    } catch (error) {
      console.error("Error during registration:", error);
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Terjadi kesalahan saat mendaftarkan pengguna.";
      Swal.fire("Error", errorMessage, "error");
    }
  };

  const handleLahanSubmit = async () => {
    if (
      !lahanFormData.nama_lahan ||
      !lahanFormData.alamat_lahan ||
      !lahanFormData.status_sertifikasi_lahan ||
      !lahanFormData.luas_lahan
    ) {
      Swal.fire("Peringatan", "Semua kolom wajib diisi!", "warning");
      return;
    }

    try {
      const payload = {
        petani_id: selectedPetani.id,
        nama_lahan: lahanFormData.nama_lahan,
        alamat_lahan: lahanFormData.alamat_lahan,
        status_sertifikasi_lahan: lahanFormData.status_sertifikasi_lahan,
        luas_lahan: parseFloat(lahanFormData.luas_lahan),
        jenis_tanah: lahanFormData.jenis_tanah,
      };

      const response = await axios.post(
        "https://c-greenproject.org:7500/tambah_lahan",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      Swal.fire({
        title: "Berhasil!",
        text: response.data.message || "Lahan berhasil ditambahkan.",
        icon: "success",
        confirmButtonColor: "#198754",
      });

      setShowLahanModal(false);

      const res = await axios.get("https://c-greenproject.org:7500/users");
      setStakeholderData(res.data.users || []);
    } catch (error) {
      console.error("Error adding lahan:", error);
      const errorMsg =
        error.response?.data?.error || "Gagal menambahkan lahan baru.";
      Swal.fire("Error", errorMsg, "error");
    }
  };

  const handleDetail = (id) => {
    navigate(`/admins/detail/${id}`);
  };

  const handleDelete = async (userId, username) => {
    Swal.fire({
      title: "Konfirmasi Hapus",
      text: `Apakah Anda yakin ingin menghapus pengguna "${username || "ini"}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Ya, Hapus!",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `https://c-greenproject.org:7500/delete?id=${userId}`,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.status === 200) {
            Swal.fire({
              title: "Terhapus!",
              text: "Pengguna berhasil dihapus.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });

            setStakeholderData((prevData) =>
              prevData.filter((user) => user.id !== userId)
            );
          } else {
            Swal.fire(
              "Error",
              response.data.error || "Gagal menghapus pengguna.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error during delete:", error.response || error);
          Swal.fire(
            "Error",
            error.response?.data?.error ||
              "Terjadi kesalahan saat menghapus pengguna.",
            "error"
          );
        }
      }
    });
  };

  const getRoleBadge = (role) => {
    const r = String(role || "").toLowerCase().trim();
    if (r === "petani")
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1 rounded-pill">
          Petani
        </span>
      );
    if (r === "logistik")
      return (
        <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-1 rounded-pill">
          Logistik
        </span>
      );
    if (r === "pabrik")
      return (
        <span className="badge bg-info-subtle text-info-emphasis border border-info-subtle px-3 py-1 rounded-pill">
          Pabrik
        </span>
      );
    if (r === "kebun")
      return (
        <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-1 rounded-pill">
          Kebun
        </span>
      );
    return (
      <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle px-3 py-1 rounded-pill">
        {role || "-"}
      </span>
    );
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">
            Portal Sistem Traceability
          </p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">
            Telsa Super Apps
          </h6>
          <p
            id="sidebar-date"
            className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2"
          >
            <img
              src="/static/schedule_11145854.png"
              alt="Date"
              style={{ width: "16px" }}
            />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/admin")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/admin" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/eco-home_7633847.png"
                alt="Home"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter:
                    location.pathname === "/admin"
                      ? "brightness(0) invert(1)"
                      : "none",
                }}
              />{" "}
              Beranda
            </div>
            <div
              onClick={() => navigate("/admins")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/admins")
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img
                src="/static/sell_8087698.png"
                alt="Stakeholder"
                style={{
                  width: "20px",
                  marginRight: "10px",
                  filter: location.pathname.includes("/admins")
                    ? "brightness(0) invert(1)"
                    : "none",
                }}
              />{" "}
              Stakeholder
            </div>
          </div>
        </div>

        <div className="main-content flex-grow-1 p-4 w-100">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Manajemen Stakeholder</h2>
            <button
              className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
              onClick={handleOpenRegisterModal}
            >
              <i className="fa fa-user-plus me-2"></i>Tambah Pengguna
            </button>
          </div>

          <div className="divider mb-4"></div>

          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <div className="row align-items-center mb-4 pb-3 border-bottom">
              <div className="col-md-4">
                <label
                  htmlFor="roleFilter"
                  className="fw-bold text-muted small mb-2"
                >
                  Filter Berdasarkan Role:
                </label>
                <select
                  id="roleFilter"
                  value={selectedRole}
                  onChange={handleRoleChange}
                  className="form-select rounded-pill shadow-sm"
                >
                  <option value="All">Semua Role</option>
                  <option value="petani">Petani</option>
                  <option value="logistik">Logistik</option>
                  <option value="pabrik">Pabrik</option>
                  <option value="kebun">Kebun</option>
                </select>
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data stakeholder...</p>
              </div>
            ) : filteredData.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table
                  className="table table-hover align-middle"
                  style={{ minWidth: "800px" }}
                >
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th
                        className="text-center py-3"
                        style={{ width: "60px", borderTopLeftRadius: "10px" }}
                      >
                        No
                      </th>
                      <th className="py-3">Nama Pengguna</th>
                      <th className="py-3 text-center">No. HP</th>
                      <th className="text-center py-3">Role</th>
                      <th
                        className="text-center py-3"
                        style={{ width: "240px", borderTopRightRadius: "10px" }}
                      >
                        Aksi
                      </th>
                    </tr>
                  </thead>

                  <tbody key={selectedRole}>
                    {filteredData.map((stakeholder, index) => (
                      <tr key={`user-${stakeholder.id || index}`}>
                        <td className="text-center fw-bold text-muted">
                          {index + 1}
                        </td>
                        <td className="fw-semibold text-dark text-capitalize text-nowrap">
                          {stakeholder.nama || stakeholder.username || "-"}
                        </td>
                        <td className="text-center text-muted font-monospace text-nowrap">
                          {stakeholder.nomor_hp || "-"}
                        </td>
                        <td className="text-center text-nowrap">
                          {getRoleBadge(stakeholder.role)}
                        </td>
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-1.5">
                            {stakeholder.role === "petani" && (
                              <button
                                className="btn btn-outline-success btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                                onClick={() => handleOpenLahanModal(stakeholder)}
                              >
                                + Lahan
                              </button>
                            )}
                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() => handleDetail(stakeholder.id)}
                            >
                              Detail
                            </button>
                            <button
                              className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                              onClick={() =>
                                handleDelete(
                                  stakeholder.id,
                                  stakeholder.username || stakeholder.nama
                                )
                              }
                            >
                              Hapus
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-3">
                <i
                  className="fa fa-users mb-3 opacity-50"
                  style={{ fontSize: "3rem" }}
                ></i>
                <h5 className="fw-semibold">Tidak Ada Data</h5>
                <p className="mb-0">
                  Tidak ditemukan pengguna untuk filter role ini.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showRegisterModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">
                  Tambah Pengguna Baru
                </h5>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={() => setShowRegisterModal(false)}
                ></button>
              </div>
              <div
                className="modal-body px-4 py-3"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Username
                  </label>
                  <input
                    type="text"
                    name="username"
                    placeholder="Masukkan username"
                    className="form-control rounded-3"
                    value={formData.username}
                    onChange={(e) =>
                      setFormData({ ...formData, username: e.target.value })
                    }
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    placeholder="Masukkan password"
                    className="form-control rounded-3"
                    value={formData.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Masukkan email"
                    className="form-control rounded-3"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Role
                  </label>
                  <select
                    name="role"
                    className="form-select rounded-3"
                    value={formData.role}
                    onChange={(e) =>
                      setFormData({ ...formData, role: e.target.value })
                    }
                  >
                    <option value="">Pilih Role</option>
                    <option value="petani">Petani</option>
                    <option value="kebun">Kebun</option>
                    <option value="logistik">Logistik</option>
                    <option value="pabrik">Pabrik</option>
                  </select>
                </div>

                {formData.role === "petani" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nama Petani
                      </label>
                      <input
                        type="text"
                        name="nama"
                        placeholder="Nama lengkap"
                        className="form-control rounded-3"
                        value={formData.nama}
                        onChange={(e) =>
                          setFormData({ ...formData, nama: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nomor HP
                      </label>
                      <input
                        type="text"
                        name="nomor_hp"
                        placeholder="Nomor HP"
                        className="form-control rounded-3"
                        value={formData.nomor_hp}
                        onChange={(e) =>
                          setFormData({ ...formData, nomor_hp: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Alamat Rumah
                      </label>
                      <input
                        type="text"
                        name="alamat_rumah"
                        placeholder="Alamat rumah"
                        className="form-control rounded-3"
                        value={formData.alamat_rumah}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            alamat_rumah: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nama Lahan
                      </label>
                      <input
                        type="text"
                        name="nama_lahan"
                        placeholder="Nama lahan"
                        className="form-control rounded-3"
                        value={formData.lahans[0].nama_lahan}
                        onChange={(e) => {
                          const newLahans = [...formData.lahans];
                          newLahans[0].nama_lahan = e.target.value;
                          setFormData({ ...formData, lahans: newLahans });
                        }}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Alamat Lahan
                      </label>
                      <input
                        type="text"
                        name="alamat_lahan"
                        placeholder="Alamat lahan"
                        className="form-control rounded-3"
                        value={formData.lahans[0].alamat_lahan}
                        onChange={(e) => {
                          const newLahans = [...formData.lahans];
                          newLahans[0].alamat_lahan = e.target.value;
                          setFormData({ ...formData, lahans: newLahans });
                        }}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Status Sertifikasi Lahan
                      </label>
                      <input
                        type="text"
                        name="status_sertifikasi_lahan"
                        placeholder="Contoh: Sertifikat / Belum"
                        className="form-control rounded-3"
                        value={formData.lahans[0].status_sertifikasi_lahan}
                        onChange={(e) => {
                          const newLahans = [...formData.lahans];
                          newLahans[0].status_sertifikasi_lahan = e.target.value;
                          setFormData({ ...formData, lahans: newLahans });
                        }}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Luas Lahan (Ha)
                      </label>
                      <input
                        type="number"
                        name="luas_lahan"
                        placeholder="Luas dalam hektar"
                        className="form-control rounded-3"
                        value={formData.lahans[0].luas_lahan}
                        onChange={(e) => {
                          const newLahans = [...formData.lahans];
                          newLahans[0].luas_lahan = e.target.value;
                          setFormData({ ...formData, lahans: newLahans });
                        }}
                      />
                    </div>
                  </>
                )}

                {formData.role === "kebun" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nama Kebun
                      </label>
                      <input
                        type="text"
                        name="nama"
                        placeholder="Nama kebun"
                        className="form-control rounded-3"
                        value={formData.nama}
                        onChange={(e) =>
                          setFormData({ ...formData, nama: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nomor HP
                      </label>
                      <input
                        type="text"
                        name="nomor_hp"
                        placeholder="Nomor HP"
                        className="form-control rounded-3"
                        value={formData.nomor_hp}
                        onChange={(e) =>
                          setFormData({ ...formData, nomor_hp: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Alamat Kebun
                      </label>
                      <input
                        type="text"
                        name="alamat_kebun"
                        placeholder="Alamat kebun"
                        className="form-control rounded-3"
                        value={formData.alamat_kebun}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            alamat_kebun: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Jenis Sawit
                      </label>
                      <input
                        type="text"
                        name="jenis_sawit"
                        placeholder="Jenis sawit"
                        className="form-control rounded-3"
                        value={formData.jenis_sawit}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            jenis_sawit: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Jenis Pupuk
                      </label>
                      <input
                        type="text"
                        name="jenis_pupuk"
                        placeholder="Jenis pupuk"
                        className="form-control rounded-3"
                        value={formData.jenis_pupuk}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            jenis_pupuk: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}

                {formData.role === "logistik" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nama Logistik
                      </label>
                      <input
                        type="text"
                        name="nama"
                        placeholder="Nama perusahaan/logistik"
                        className="form-control rounded-3"
                        value={formData.nama}
                        onChange={(e) =>
                          setFormData({ ...formData, nama: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nomor HP
                      </label>
                      <input
                        type="text"
                        name="nomor_hp"
                        placeholder="Nomor HP"
                        className="form-control rounded-3"
                        value={formData.nomor_hp}
                        onChange={(e) =>
                          setFormData({ ...formData, nomor_hp: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Alamat
                      </label>
                      <input
                        type="text"
                        name="alamat"
                        placeholder="Alamat"
                        className="form-control rounded-3"
                        value={formData.alamat_rumah}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            alamat_rumah: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}

                {formData.role === "pabrik" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nama Pabrik
                      </label>
                      <input
                        type="text"
                        name="nama"
                        placeholder="Nama pabrik"
                        className="form-control rounded-3"
                        value={formData.nama}
                        onChange={(e) =>
                          setFormData({ ...formData, nama: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Nomor HP
                      </label>
                      <input
                        type="text"
                        name="nomor_hp"
                        placeholder="Nomor HP"
                        className="form-control rounded-3"
                        value={formData.nomor_hp}
                        onChange={(e) =>
                          setFormData({ ...formData, nomor_hp: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Alamat Pabrik
                      </label>
                      <input
                        type="text"
                        name="alamat_pabrik"
                        placeholder="Alamat pabrik"
                        className="form-control rounded-3"
                        value={formData.alamat_pabrik}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            alamat_pabrik: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Kapasitas Penyimpanan
                      </label>
                      <input
                        type="text"
                        name="kapasitas_penyimpanan"
                        placeholder="Kapasitas penyimpanan"
                        className="form-control rounded-3"
                        value={formData.kapasitas_penyimpanan}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            kapasitas_penyimpanan: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">
                        Kapasitas Produksi
                      </label>
                      <input
                        type="text"
                        name="kapasitas_produksi"
                        placeholder="Kapasitas produksi"
                        className="form-control rounded-3"
                        value={formData.kapasitas_produksi}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            kapasitas_produksi: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4 fw-medium"
                  onClick={() => setShowRegisterModal(false)}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-success rounded-pill px-4 fw-bold shadow-sm"
                  onClick={handleRegisterSubmit}
                >
                  Simpan Pengguna
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLahanModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <div>
                  <h5 className="modal-title fw-bold text-dark">
                    Tambah Plot Lahan
                  </h5>
                  <p className="text-muted small mb-0">
                    Petani:{" "}
                    <strong>
                      {selectedPetani?.nama || selectedPetani?.username}
                    </strong>
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={() => setShowLahanModal(false)}
                ></button>
              </div>

              <div className="modal-body px-4 py-3">
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Nama Lahan
                  </label>
                  <input
                    type="text"
                    placeholder="Contoh: Lahan Blok Barat"
                    className="form-control rounded-3"
                    value={lahanFormData.nama_lahan}
                    onChange={(e) =>
                      setLahanFormData({
                        ...lahanFormData,
                        nama_lahan: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Alamat / Lokasi Lahan
                  </label>
                  <textarea
                    rows="2"
                    placeholder="Alamat lengkap lokasi lahan"
                    className="form-control rounded-3"
                    value={lahanFormData.alamat_lahan}
                    onChange={(e) =>
                      setLahanFormData({
                        ...lahanFormData,
                        alamat_lahan: e.target.value,
                      })
                    }
                  ></textarea>
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">
                    Status Sertifikasi Lahan
                  </label>
                  <select
                    className="form-select rounded-3"
                    value={lahanFormData.status_sertifikasi_lahan}
                    onChange={(e) =>
                      setLahanFormData({
                        ...lahanFormData,
                        status_sertifikasi_lahan: e.target.value,
                      })
                    }
                  >
                    <option value="">Pilih Status</option>
                    <option value="Sertifikat (SHM)">Sertifikat (SHM)</option>
                    <option value="HGU / HGB">HGU / HGB</option>
                    <option value="Girik / Letter C">Girik / Letter C</option>
                    <option value="Belum Bersertifikat">
                      Belum Bersertifikat
                    </option>
                  </select>
                </div>

                <div className="row g-2 mb-3">
                  <div className="col-md-6">
                    <label className="fw-semibold text-muted small mb-1">
                      Luas Lahan (Ha)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      placeholder="0.0"
                      className="form-control rounded-3"
                      value={lahanFormData.luas_lahan}
                      onChange={(e) =>
                        setLahanFormData({
                          ...lahanFormData,
                          luas_lahan: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="fw-semibold text-muted small mb-1">
                      Jenis Tanah
                    </label>
                    <input
                      type="text"
                      placeholder="Contoh: Mineral / Gambut"
                      className="form-control rounded-3"
                      value={lahanFormData.jenis_tanah}
                      onChange={(e) =>
                        setLahanFormData({
                          ...lahanFormData,
                          jenis_tanah: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4 fw-medium"
                  onClick={() => setShowLahanModal(false)}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-success rounded-pill px-4 fw-bold shadow-sm"
                  onClick={handleLahanSubmit}
                >
                  Simpan Lahan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDS;